import axios from 'axios';
import { installApiErrorTranslator } from './apiErrors';

// إنشاء نسخة مخصصة من axios
const api = axios.create({
  baseURL: '/api',
});

// 1. Interceptor للطلبات (إضافة التوكن تلقائياً)
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// 2. Interceptor للردود (قناص الـ 401)
api.interceptors.response.use(
  (response) => response, // لو الرد سليم، مرره عادي
  (error) => {
    if (error.response && error.response.status === 401) {
      console.warn("🚫 Unauthorized! Redirecting to login...");
      
      // مسح البيانات المنتهية
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      
      // توجيه لصفحة اللوجن (باستخدام window.location لضمان إعادة تحميل الأبليكيشن)
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// 3. 🎯 نفس القناص على axios الافتراضي - أغلب الشاشات (حوالي 120 ملف) بتستخدم
// axios مباشرة مش api، فتوكن منتهي كان بيطلّع أخطاء في الشاشة من غير ما يودي
// للوجين. بنطلّع المستخدم بس لما التوكن نفسه يترفض من get_current_user - مش
// أي 401 (زي كود تحقق غلط في تغيير الباسورد أو باسورد غلط في اللوجين)
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const rejectedToken =
      error.response?.status === 401 &&
      error.response?.data?.detail === 'Could not validate credentials';
    if (rejectedToken && window.location.pathname !== '/login') {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      localStorage.removeItem('lastActivity');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// 4. 🎯 ترجمة رسائل الخطأ حسب لغة اليوزر (أكواد أخطاء الداتابيز، detail
// الـ Object/Array اللي كان بيظهر "[object Object]") - راجع apiErrors.js
installApiErrorTranslator(api);
installApiErrorTranslator(axios);

export default api;